
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const LandingCTA = () => {
    return (
        <section className="py-24 bg-white relative overflow-hidden">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/10 via-transparent to-transparent pointer-events-none" />

            <div className="container mx-auto px-4 relative text-center">
                <h2 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
                    Launch your first giveaway today.
                </h2>
                <p className="text-xl text-gray-500 max-w-2xl mx-auto mb-10">
                    Join thousands of small businesses growing with RaffleKit.
                </p>

                <div className="flex flex-col sm:flex-row justify-center gap-4">
                    <Button asChild size="lg" variant="accent" className="font-bold text-lg h-14 px-10 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all">
                        <Link to="/admin?mode=signup">
                            Get Started for Free
                        </Link>
                    </Button>
                    <Button asChild variant="outline" size="lg" className="h-14 px-10 rounded-full bg-white">
                        <a href="#pricing">See Pricing</a>
                    </Button>
                </div>
            </div>
        </section>
    );
};
